export default __webpack_public_path__ + "static/media/bg-overlay-section6.55d97ca8.png";